import {createSelector} from 'reselect';

import {getUIState} from '../../../ui-selectors';

import type {NutshellState} from '../../../../store';

const getOnboardingState = createSelector([getUIState], (uiState) => uiState.onboarding);

export const getIsOnboardingSidebarDismissed = (state: NutshellState) => {
    return getOnboardingState(state).isOnboardingSidebarDismissed;
};
